/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_LevelInputs */

const id_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const ms_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap`)
};

const da_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const en_us2_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const es_es2_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const es_mx2_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const fil_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const fr_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const it_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

const hu_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szint`)
};

const nl_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const no_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivå`)
};

const pl_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziom`)
};

const pt_br2_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const pt_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const ro_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const fi_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taso`)
};

const sv_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivå`)
};

const vi_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấp độ`)
};

const tr_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seviye`)
};

const cs_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úroveň`)
};

const bg_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ниво`)
};

const ru_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень`)
};

const uk_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рівень`)
};

const ar_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستوى`)
};

const hi_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्तर`)
};

const th_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลเวล`)
};

const ja_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レベル`)
};

const zh_cn2_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等级`)
};

const zh_hant1_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等級`)
};

const ko_profile_hero_level = /** @type {(inputs: Profile_Hero_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레벨`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Profile_Hero_LevelInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_level = /** @type {((inputs?: Profile_Hero_LevelInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_LevelInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_level(inputs)
	if (locale === "ms") return ms_profile_hero_level(inputs)
	if (locale === "da") return da_profile_hero_level(inputs)
	if (locale === "de") return de_profile_hero_level(inputs)
	if (locale === "en-US") return en_us2_profile_hero_level(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_level(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_level(inputs)
	if (locale === "fil") return fil_profile_hero_level(inputs)
	if (locale === "fr") return fr_profile_hero_level(inputs)
	if (locale === "it") return it_profile_hero_level(inputs)
	if (locale === "hu") return hu_profile_hero_level(inputs)
	if (locale === "nl") return nl_profile_hero_level(inputs)
	if (locale === "no") return no_profile_hero_level(inputs)
	if (locale === "pl") return pl_profile_hero_level(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_level(inputs)
	if (locale === "pt") return pt_profile_hero_level(inputs)
	if (locale === "ro") return ro_profile_hero_level(inputs)
	if (locale === "fi") return fi_profile_hero_level(inputs)
	if (locale === "sv") return sv_profile_hero_level(inputs)
	if (locale === "vi") return vi_profile_hero_level(inputs)
	if (locale === "tr") return tr_profile_hero_level(inputs)
	if (locale === "cs") return cs_profile_hero_level(inputs)
	if (locale === "bg") return bg_profile_hero_level(inputs)
	if (locale === "ru") return ru_profile_hero_level(inputs)
	if (locale === "uk") return uk_profile_hero_level(inputs)
	if (locale === "ar") return ar_profile_hero_level(inputs)
	if (locale === "hi") return hi_profile_hero_level(inputs)
	if (locale === "th") return th_profile_hero_level(inputs)
	if (locale === "ja") return ja_profile_hero_level(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_level(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_level(inputs)
	return ko_profile_hero_level(inputs)
});
export { profile_hero_level as "profile.hero.level" }